// NOTE: This is a draft legal text. Review by a legal professional is recommended.
import LegalPage from "@/components/LegalPage";
import { LEGAL_VERSIONS } from "@/lib/legalVersions";

export default function KvkkNoticeEn() {
  return (
    <LegalPage
      lang="en"
      title="KVKK Notice"
      subtitle="Information notice under Turkey's Personal Data Protection Law (KVKK) for users connecting to uSeen from Turkey."
      lastUpdated="May 2026"
      version={LEGAL_VERSIONS.kvkk}
      testid="kvkk-page-en"
    >
      <h2>1. Data Controller</h2>
      <p>
        uSeen acts as the data controller for personal data processed through
        the platform. Contact details for the data controller are available on
        the public contact page.
      </p>

      <h2>2. Purpose of Processing</h2>
      <p>
        Your personal data is processed for the following purposes:
      </p>
      <ul>
        <li>To deliver the AI visibility analysis and tasks you request.</li>
        <li>To create and maintain your user account.</li>
        <li>To ensure platform security and prevent fraud.</li>
        <li>To meet legal obligations.</li>
      </ul>

      <h2>3. Legal Basis</h2>
      <p>
        Processing is based on, where applicable: (a) the contract you enter
        into when creating an account, (b) your explicit consent for optional
        categories (analytics, marketing), (c) our legitimate interests in
        security and product improvement, and (d) legal obligations.
      </p>

      <h2>4. Recipients</h2>
      <p>
        Your data may be shared with our hosting provider, AI model providers,
        and analytics vendors strictly to operate the service. We do not sell
        your data.
      </p>

      <h2>5. Transfer Outside Turkey</h2>
      <p>
        Where service providers are located outside Turkey, transfers are made
        based on applicable KVKK conditions and appropriate safeguards.
      </p>

      <h2>6. Your Rights Under KVKK Article 11</h2>
      <p>
        You have the right to learn whether your personal data is being
        processed, request information about the processing, request
        correction or deletion, object to results obtained through automated
        processing, and request compensation for damages caused by unlawful
        processing.
      </p>

      <h2>7. Exercising Your Rights</h2>
      <p>
        You can exercise these rights by contacting us through the contact
        page. We will respond within the timeframes required by law.
      </p>
    </LegalPage>
  );
}
